import React, { useState } from 'react';
import axios from 'axios';

const AiAssistant = () => {
  const [input, setInput] = useState('');
  const [response, setResponse] = useState('');
  const [loading, setLoading] = useState(false);

  const callAI = async () => {
    setLoading(true);
    try {
      const result = await axios.post(
        'https://api.openai.com/v1/completions',
        {
          model: 'text-davinci-003',
          prompt: input,
          max_tokens: 100,
        },
        {
          headers: {
            Authorization: `Bearer YOUR_OPENAI_API_KEY`, // ⚠️ Replace with your key
          },
        }
      );
      setResponse(result.data.choices[0].text.trim());
    } catch (err) {
      setResponse('Error: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 600, margin: 'auto', padding: 20, fontFamily: 'Arial' }}>
      <h2>AI Assistant Demo</h2>
      <textarea
        rows={4}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Ask me anything..."
        style={{ width: '100%', padding: 10, fontSize: 16 }}
      />
      <button
        onClick={callAI}
        style={{ marginTop: 10, padding: '10px 20px', fontSize: 16 }}
        disabled={loading}
      >
        {loading ? 'Thinking...' : 'Ask AI'}
      </button>

      {response && (
        <div style={{ marginTop: 20, whiteSpace: 'pre-wrap', background: '#f4f4f4', padding: 15 }}>
          <strong>Response:</strong>
          <br />
          {response}
        </div>
      )}
    </div>
  );
};

export default AiAssistant;
